export default __webpack_public_path__ + "a3590b5908e9f5a67ad41741457bff66.svg";